import { createTheme as createMuiTheme, responsiveFontSizes } from '@mui/material/styles';
import merge from 'lodash/merge';

import { baseThemeOptions } from './BaseThemeOptions';
import { darkThemeOptions } from './DarkThemeOptions';
import { lightThemeOptions } from './LightThemeOptions';

import type { Direction, Theme } from '@mui/material';

interface ThemeConfig {
  direction?: Direction;
  responsiveFontSizes?: boolean;
  mode: 'light' | 'dark';
}

export const createTheme = (config: ThemeConfig): Theme => {
  let theme = createMuiTheme(
    merge({}, baseThemeOptions, config.mode === 'dark' ? darkThemeOptions : lightThemeOptions, {
      direction: config.direction,
    })
  );

  if (config.responsiveFontSizes) {
    theme = responsiveFontSizes(theme);
  }

  return theme;
};
